import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId } from "react";
import * as S from "./styled.js";
export const RadioButton = /*#__PURE__*/ forwardRef(({ label , id =null , value , checked =false , disabled =false , count , onChange , onBlur , hasError , className , variant ='default' , extended =false , rightContent , ...rest }, ref)=>{
    const radioId = useId();
    return /*#__PURE__*/ _jsxs(S.RadioButtonItemWrapper, {
        $withCount: typeof count == 'number',
        $variant: variant,
        $extended: extended,
        className: className,
        children: [
            /*#__PURE__*/ _jsx(S.RadioButtonInput, {
                ref: ref,
                type: "radio",
                id: id ?? radioId,
                value: value,
                checked: checked,
                disabled: disabled,
                onChange: onChange,
                onBlur: onBlur,
                role: "radio",
                "data-testid": "RadioButton",
                ...rest
            }),
            /*#__PURE__*/ _jsxs(S.RadioButtonLabel, {
                $checked: checked,
                $withCount: typeof count == 'number',
                htmlFor: id ?? radioId,
                $hasError: hasError,
                $disabled: disabled,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: label
                    }),
                    rightContent && /*#__PURE__*/ _jsx(S.RadioButtonRightContent, {
                        children: rightContent
                    }),
                    count && /*#__PURE__*/ _jsx(S.RadioButtonLabelCount, {
                        children: count
                    })
                ]
            })
        ]
    });
});
RadioButton.displayName = 'RadioButton';
export default RadioButton;

//# sourceMappingURL=index.js.map